(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["auto-scrolling-images"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const scrollingTrack = document.querySelector('.scrolling-track');
  
  if (scrollingTrack) {
    // Check if we need to duplicate images more times for wider screens
    const adjustAnimationForScreenSize = () => {
      const trackWidth = scrollingTrack.offsetWidth;
      const windowWidth = window.innerWidth;
      
      // If the track isn't twice as wide as the window, add more duplicates
      if (trackWidth < windowWidth * 2) {
        const items = Array.from(document.querySelectorAll('.scrolling-item'));
        const itemsToClone = items.slice(0, items.length / 2); // Just clone the first set
        
        itemsToClone.forEach(item => {
          const clone = item.cloneNode(true);
          scrollingTrack.appendChild(clone);
        });
      }
    };
    
    // Run once on load and again if window is resized
    adjustAnimationForScreenSize();
    window.addEventListener('resize', adjustAnimationForScreenSize);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      if (document.body.classList.contains('template-index') && 'ResizeObserver' in window) {
        this.headerResizeObserver = new ResizeObserver((entries) => {
          const borderBox = entries[0].borderBoxSize;
          const size = borderBox?.[0] || borderBox;
          if (!size || !Number.isFinite(size.blockSize)) return;

          const height = Math.round(size.blockSize);
          if (height === this.headerHeight) return;
          this.headerHeight = height;
          document.documentElement.style.setProperty('--header-height', `${height}px`);
        });
        this.headerResizeObserver.observe(this.header, { box: 'border-box' });
      } else {
        this.setHeaderHeight();
        this.headerBreakpoint = window.matchMedia('(max-width: 990px)');
        this.onHeaderBreakpointChange = this.setHeaderHeight.bind(this);
        this.headerBreakpoint.addEventListener('change', this.onHeaderBreakpointChange);
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.headerResizeObserver?.disconnect();
      this.headerIntersectionObserver?.disconnect();
      this.headerBreakpoint?.removeEventListener('change', this.onHeaderBreakpointChange);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      this.headerIntersectionObserver = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      this.headerIntersectionObserver.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
